import { render, staticRenderFns } from "./edit-pass.vue?vue&type=template&id=be2d867a&scoped=true"
import script from "./edit-pass.vue?vue&type=script&lang=js"
export * from "./edit-pass.vue?vue&type=script&lang=js"
import style0 from "./edit-pass.vue?vue&type=style&index=0&id=be2d867a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2d867a",
  null
  
)

export default component.exports